import { ref as h, computed as l, readonly as F, getCurrentScope as Ee, onScopeDispose as ye, defineComponent as ve, defineAsyncComponent as G, toRefs as V, watch as x, onMounted as Ae, createElementBlock as we, openBlock as b, withDirectives as k, createCommentVNode as W, unref as S, createBlock as B, resolveDynamicComponent as Y, vShow as j, createApp as Ce } from "vue";
const Re = (e) => (e ?? "").trim().toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, ""), _e = (e) => e().toString(36).slice(2, 9), q = (e, t = Math.random, n = Re) => {
  const r = n(e), o = _e(t);
  return `${r}-${o}`;
}, De = (e = document) => e.readyState === "loading", v = {
  APP_MOUNT_SELECTOR: "div[data-js=search-input-suggestions]",
  SEARCH_INPUT: "input[data-js=search-field]",
  SEARCH_FORM: "form[data-js=search-form]",
  LEGACY_SEARCH_HISTORY: "div[data-js=recent-search-box]"
}, z = "#gnav-data", He = {
  ENTER: "Enter",
  ESC: "Escape",
  ARROW_UP: "ArrowUp",
  ARROW_DOWN: "ArrowDown",
  ARROW_LEFT: "ArrowLeft",
  ARROW_RIGHT: "ArrowRight",
  HOME: "Home",
  END: "End"
}, K = {
  AUTOSUGGEST: "autosuggest-result-",
  SEARCH_HISTORY: "search-history-entry-"
}, Yt = "Search Suggestions", g = -1, f = {
  shouldMountAutosuggest: !1,
  shouldMountSearchHistory: !1,
  maxSearchHistoryResults: 10
}, Te = (e) => {
  const {
    enableAutosuggest: t = !1,
    enableRecentSearch: n = !1,
    recentSearchMaxSize: r = 10,
    useConstructorAutosuggest: o = !1
  } = e;
  f.shouldMountAutosuggest = !!t && !!o, f.shouldMountSearchHistory = ee() && !!n, f.maxSearchHistoryResults = r;
}, R = /* @__PURE__ */ new Map(), X = (e) => {
  const t = je(e);
  if (!t) return {};
  const n = {
    source: "domElems.getGnavDataJson",
    selector: e
  };
  let r = M(t, n);
  if (typeof r != "object" || r === null || Array.isArray(M)) {
    const o = new Error("Invalid JSON structure in gnav-data script");
    d(o, n), r = {};
  }
  return r;
}, A = (e) => {
  if (R.has(e))
    return R.get(e);
  try {
    const t = document.querySelector(e);
    if (t instanceof HTMLElement)
      return R.set(e, t), t;
  } catch (t) {
    d(t, {
      source: "domElems.getDOMElem",
      selector: e
    });
  }
  return R.set(e, null), null;
}, Le = (e) => {
  let t;
  try {
    t = document.querySelector(e);
  } catch {
  }
  return t instanceof HTMLElement;
}, xe = (e) => {
  const t = {};
  Object.entries(e).forEach(([r, o]) => {
    t[r] = A(o);
  });
  const n = Object.entries(t).filter(([, r]) => r === null).map(([r]) => e[r]);
  if ((n == null ? void 0 : n.length) > 0) {
    const r = new Error("Autosuggest missing required DOM elements");
    return d(r, {
      source: "domElems.validateAndCacheDomElems",
      missingSelectors: n
    }), !1;
  }
  return !0;
}, be = (e = {}) => {
  const {
    gnavDataJsonSelector: t = z
  } = e, n = X(t);
  return Te(n), f.shouldMountAutosuggest || f.shouldMountSearchHistory;
}, Z = "searchHistory", Ie = () => {
  const e = X(z);
  let t = Number(e == null ? void 0 : e.recentSearchMaxSize);
  return (typeof t != "number" || Number.isNaN(t) || t < 4 || t > 10) && (t = 10), t;
}, Oe = () => {
  const e = { source: "searchHistory.getRawSearchHistory" }, t = oe(Z);
  if (!t) return [];
  const n = M(t, e);
  if (typeof n != "object" || n === null || !Array.isArray(n)) {
    const r = new Error("Invalid JSON structure for search history");
    return d(r, e), [];
  }
  return n;
}, Me = (e) => {
  const t = e.trim();
  if (!t) return;
  const r = Oe().filter(
    (a) => a.searchTerm.toLowerCase() !== t.toLowerCase()
  );
  r.unshift({ searchTerm: t });
  const o = Ie(), s = r.slice(0, o);
  Ge(Z, JSON.stringify(s));
}, Ne = {
  ENABLE_SEARCH_HISTORY: "enableSearchHistory"
}, ee = () => oe(Ne.ENABLE_SEARCH_HISTORY) === "true", Fe = () => {
  const e = A(v.LEGACY_SEARCH_HISTORY);
  e && (e.style.display = "none");
}, te = (e = {}) => {
  const t = be(e), n = xe(v);
  return t && n;
}, $e = (e) => e.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"), Ue = (e) => new RegExp(`(\\b${e}\\b|${e})`, "gi"), Pe = (e, t, n, r) => e.split(n).filter((s) => s && s.length > 0).map((s, a) => ({
  text: s.replace(/ /g, " "),
  // Use non-breaking spaces
  queryText: s.toLowerCase() === r,
  key: `${t}-part-${a}`
}));
function Je(e, t) {
  var u;
  const n = (u = e == null ? void 0 : e.sections) == null ? void 0 : u["Search Suggestions"];
  if (!t || !n || !Array.isArray(n))
    return [];
  const r = t.toLowerCase(), o = $e(r), s = Ue(o);
  return n.slice(0, 10).map((C) => {
    const L = C.value, J = q(C.data.id || L), pe = Pe(L, J, s, r);
    return {
      term: L,
      key: J,
      termParts: pe,
      // We can include other original data if needed
      ...C.data
    };
  });
}
const ne = () => window.localStorage ? window.localStorage : null, re = (e, t) => {
  console.error(`[localStorage] Unavailable when calling ${e}("${t}")`);
}, oe = (e) => {
  const t = ne();
  if (!t)
    return re("getLocalStorageByKey", e), null;
  try {
    return t.getItem(e);
  } catch (n) {
    return console.error(`[localStorage] getItem failed for "${e}":`, n), null;
  }
}, Ge = (e, t) => {
  const n = ne();
  if (!n) {
    re("setLocalStorageByKey", e);
    return;
  }
  try {
    n.setItem(e, t);
  } catch (r) {
    console.error(`[localStorage] setItem failed for "${e}":`, r);
  }
}, Ve = (e, t) => {
  var o, s;
  const n = (s = (o = window == null ? void 0 : window.document) == null ? void 0 : o.location) == null ? void 0 : s.hostname;
  if (!(n == null ? void 0 : n.includes("www.rei.com"))) {
    const a = {
      component: "SearchInputSuggestions",
      vendor: "C9r",
      ...t
    }, u = "color: red;";
    console.group("%cError in Search Input Suggestions", u), console.log(`%cMessage: ${e.message}`, u), console.log("%cContext:", u), console.dir(a), console.groupEnd();
  }
}, ke = (e = 5e3, t = 500) => new Promise((n, r) => {
  let o = 0;
  const s = Math.ceil(e / t), a = () => {
    var u;
    typeof ((u = window == null ? void 0 : window.DD_RUM) == null ? void 0 : u.addError) == "function" ? n(window.DD_RUM) : (o += 1, o >= s ? r(new Error(`DD_RUM not available after ${s} attempts`)) : setTimeout(a, t));
  };
  a();
}), We = (e, t) => (n, r) => {
  const o = {
    component: "SearchInputSuggestions",
    vendor: "C9r",
    ...r
  };
  return t().then((s) => {
    try {
      s == null || s.addError(n, o);
    } catch (a) {
      const u = {
        ...o,
        ddRumFailure: !0,
        ddRumErrMsg: (a == null ? void 0 : a.message) ?? "Unknown DD_RUM runtime error"
      };
      e(n, u);
    }
  }).catch((s) => {
    const a = {
      ...o,
      ddRumFailure: !0,
      ddRumErrMsg: (s == null ? void 0 : s.message) ?? "Unknown DD_RUM init error"
    };
    e(n, a);
  });
}, Be = window.location.hostname.includes("localhost"), Ye = Be ? () => Promise.reject(new Error("Local dev: Skipping DD_RUM wait")) : ke, d = We(Ve, Ye), je = (e) => {
  if (!e) return null;
  let t;
  try {
    t = document.querySelector(e);
  } catch {
    return null;
  }
  return !t || !(t instanceof HTMLScriptElement) || t.getAttribute("type") !== "application/json" ? null : t.textContent;
}, M = (e, t = {}) => {
  if (e === null) return null;
  const n = { ...t, jsonTextContent: e };
  try {
    const r = JSON.parse(e.trim());
    if (typeof r != "object" || r === null) {
      const o = new Error("Invalid JSON structure in the script");
      return d(o, n), null;
    }
    return r;
  } catch (r) {
    const o = new Error(`Failed to parse JSON from script tag. Original error: ${r == null ? void 0 : r.message}`);
    return d(o, n), null;
  }
}, Ke = (e) => {
  const {
    message: t,
    stack: n,
    name: r
  } = e;
  return {
    message: t,
    stack: n,
    name: r
  };
}, I = (e) => {
  const {
    tagName: t,
    classList: n,
    id: r,
    outerHTML: o
  } = e;
  return {
    tagName: t,
    classList: Array.from(n || []),
    attributes: e.getAttributeNames(),
    id: r,
    outerHTML: o == null ? void 0 : o.slice(0, 200)
  };
}, Qe = (e) => {
  if (!e || !(e instanceof Element)) return {};
  const {
    firstElementChild: t,
    lastElementChild: n
  } = e, r = (o) => o && o instanceof Element;
  return {
    self: I(e),
    firstChild: r(t) ? I(t) : {},
    lastChild: r(n) ? I(n) : {}
  };
}, qe = (e) => {
  if (!e || !e.$options)
    return {
      componentName: "not found, invalid vm",
      elDetails: {}
    };
  const {
    $options: t,
    $el: n,
    $data: r,
    $props: o
  } = e, {
    name: s,
    __file: a
  } = t;
  return {
    componentName: s,
    fileSource: a,
    props: o,
    data: r,
    elDetails: Qe(n)
  };
}, ze = (e, t, n) => {
  if (!(e instanceof Error)) return;
  const r = {
    source: "Vue Internal Error",
    info: n,
    errorDetails: Ke(e),
    vmDetails: qe(t)
  };
  d(e, r);
}, Xe = (e, t = {}) => ({
  handler: typeof t[e.key] == "function" ? t[e.key] : () => {
  }
}), w = h(""), T = h(!1), se = l(() => w.value.trim()), Ze = l(() => !!se.value);
let c = null, _ = !1;
function et(e, t = ge) {
  Xe(e, t).handler(e);
}
function ae(e) {
  et(e, ge);
}
function ce() {
  Se(), w.value = c.value, T.value = !0;
}
function ue() {
  T.value = !1, N(g, 0);
}
function ie() {
  Se(), w.value = c.value;
}
function tt(e = v.SEARCH_INPUT) {
  _ || (c = A(e), c.addEventListener("focus", ce), c.addEventListener("blur", ue), c.addEventListener("keydown", ae), c.addEventListener("input", ie), _ = !0);
}
function nt() {
  _ && (c.removeEventListener("focus", ce), c.removeEventListener("blur", ue), c.removeEventListener("keydown", ae), c.removeEventListener("input", ie), w.value = "", T.value = !1, c = null, _ = !1);
}
function rt(e) {
  c.setAttribute("aria-expanded", String(e));
}
function ot(e) {
  c.value = e, w.value = e;
}
function st(e) {
  const t = () => {
    if (e < 0) return "";
    const n = {
      autosuggest: K.AUTOSUGGEST,
      "search history": K.SEARCH_HISTORY
    };
    return n[m.currentSuggestionType] ? `${n[m.currentSuggestionType]}${e}` : "";
  };
  c.setAttribute(
    "aria-activedescendant",
    t()
  );
}
const p = F({
  inputFieldIsFocused: T,
  cleanQuery: se,
  isValidQuery: Ze
}), { SEARCH_FORM: at } = v;
let E, D = !1;
function le() {
  Me(p.cleanQuery);
}
function ct() {
  D || (E = A(at), E.addEventListener("submit", le), D = !0);
}
function ut() {
  D && (E.removeEventListener("submit", le), E = null, D = !1);
}
function it(e) {
  if (!e) return;
  ot(e);
  const t = new CustomEvent(
    "termSelected",
    {
      bubbles: !0,
      cancelable: !0
    }
  );
  E.dispatchEvent(t);
}
const {
  ENTER: lt,
  ESC: gt,
  ARROW_UP: dt,
  ARROW_DOWN: ft,
  ARROW_LEFT: St,
  ARROW_RIGHT: mt,
  HOME: ht,
  END: pt
} = He, i = h(g);
function Et(e) {
  e.preventDefault();
  const t = m.currentSuggestionsLength;
  i.value >= t - 1 ? i.value = 0 : i.value += 1;
}
function yt(e) {
  e.preventDefault();
  const t = m.currentSuggestionsLength;
  i.value <= 0 ? i.value = t - 1 : i.value -= 1;
}
function vt() {
  i.value = g;
}
function At() {
  i.value = g;
}
function wt() {
  i.value = g;
}
function Ct(e) {
  e.preventDefault(), i.value = g;
}
function Rt() {
  var n, r;
  const e = i.value, t = (r = (n = m.currentSuggestions[e]) == null ? void 0 : n.term) == null ? void 0 : r.trim();
  e < 0 || !t || it(t);
}
function _t() {
  It();
}
const ge = {
  [lt]: Rt,
  [gt]: _t,
  [dt]: yt,
  [ft]: Et,
  [St]: vt,
  [mt]: At,
  [ht]: wt,
  [pt]: Ct
};
function N(e, t) {
  !Number.isInteger(e) || e > t || (i.value = e);
}
function Dt() {
  i.value = g;
}
const Ht = F({
  listboxActiveIndex: i
}), de = h(""), O = l(() => {
  let e = [];
  try {
    e = JSON.parse(de.value);
  } catch {
  }
  return e;
}), $ = l(
  () => O.value && Array.isArray(O.value) ? O.value.map(
    (e) => ({
      key: q(e.searchTerm),
      term: e.searchTerm
    })
  ) : []
), Tt = l(
  () => $.value.length > 0
), U = h({}), P = l(
  () => Je(U.value, p.cleanQuery)
), Lt = l(
  () => P.value.length > 0
), y = h(!1), H = l(() => y.value || !p.inputFieldIsFocused ? "none" : p.isValidQuery && Lt.value ? "autosuggest" : !p.cleanQuery && Tt.value ? "search history" : "none"), xt = l(
  () => H.value !== "none"
), fe = l(() => H.value === "autosuggest" ? P.value : H.value === "search history" ? $.value : []), bt = l(
  () => {
    var e;
    return ((e = fe.value) == null ? void 0 : e.length) || 0;
  }
);
function jt(e) {
  U.value = e;
}
function It() {
  y.value = !0;
}
function Se() {
  y.value && (y.value = !1);
}
let Q;
function Ot() {
  Q || (ee() && Fe(), Q = !0);
}
function Mt() {
  de.value = "", U.value = {}, y.value = !1;
}
const m = F({
  autosuggestSearchSuggestions: P,
  searchHistorySuggestions: $,
  currentSuggestionType: H,
  currentSuggestions: fe,
  currentSuggestionsLength: bt,
  areSuggestionsDisplayed: xt
});
function Nt() {
  nt(), ut(), Dt(), Mt();
}
function Ft() {
  if (!Ee())
    throw new Error("registerTeardownStores() must be called within setup() or a lifecycle hook.");
  ye(Nt);
}
function $t() {
  tt(), ct(), Ot(), Ft();
}
const Ut = {
  class: "search-input-suggestions"
}, Pt = /* @__PURE__ */ ve({
  __name: "SearchInputSuggestions",
  setup(e) {
    const t = G(() => import("./SearchAutosuggest-i23qKafs.mjs")), n = G(() => import("./SearchHistory-CRroqTIY.mjs")), {
      currentSuggestions: r,
      currentSuggestionType: o,
      areSuggestionsDisplayed: s
    } = V(m), {
      listboxActiveIndex: a
    } = V(Ht);
    return x(s, (u) => {
      rt(u), N(g, 0);
    }), x(r, () => {
      N(g, 0);
    }), x(a, () => {
      st(a.value);
    }), Ae(() => {
      $t();
    }), (u, C) => (b(), we("div", Ut, [S(f).shouldMountAutosuggest ? k((b(), B(Y(S(t)), {
      key: 0
    }, null, 512)), [[j, S(o) === "autosuggest"]]) : W("", !0), S(f).shouldMountSearchHistory ? k((b(), B(Y(S(n)), {
      key: 1
    }, null, 512)), [[j, S(o) === "search history"]]) : W("", !0)]));
  }
}), Jt = (e, t) => {
  const n = e.__vccOpts || e;
  for (const [r, o] of t)
    n[r] = o;
  return n;
}, Gt = /* @__PURE__ */ Jt(Pt, [["__scopeId", "data-v-f82cee2b"]]), { APP_MOUNT_SELECTOR: me } = v, he = (e, t) => {
  const n = new Error(e);
  d(n, t);
};
var Vt = /* @__PURE__ */ ((e) => (e.mount = "Failed Vue createApp and mount", e.mountDomTarget = "Missing Vue app mount rootContainer DOM target", e))(Vt || {});
const kt = (e) => {
  if (te(e)) {
    const t = A(me);
    try {
      const n = Ce(Gt);
      n.config.errorHandler = ze, n.mount(t);
    } catch (n) {
      he("Failed Vue createApp and mount", { cause: n.message, source: "initSearch" });
    }
  }
}, Wt = (e, t = !1) => {
  const n = "DOMContentLoaded";
  if (Le(me))
    kt(e);
  else if (De() && !t)
    document.addEventListener(
      n,
      () => Wt(e, !0),
      { once: !0 }
    );
  else if (te(e)) {
    const o = `initSearchWithDomLoadGuard${t ? ` from ${n}` : ""}`;
    he("Missing Vue app mount rootContainer DOM target", { source: o });
  }
};
export {
  Yt as D,
  g as I,
  Vt as M,
  Jt as _,
  m as a,
  Ht as b,
  it as c,
  Wt as d,
  p as i,
  d as l,
  jt as s,
  N as u
};
